<app-loose-categories (onSelectItem)="onSelectItem($event)"></app-loose-categories>
